import { useMutation, useQueryClient } from "@tanstack/react-query";

import { putPartnerModulesPartnerID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PARTNERS_QUERY_KEYS } from "../Queries/queryKeys";

interface SetPartnerModulesParams {
  partnerID: string;
  moduleIDs: string[];
}

export function useSetPartnerModulesMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ partnerID, moduleIDs }: SetPartnerModulesParams) =>
      putPartnerModulesPartnerID({ moduleIDs }, partnerID),
    {
      translationPrefix: getResourcePath(Resources.ApiErrors.SetPartnerModules),
    },
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { partnerID }) => {
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.modules(partnerID),
      });
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.detail(partnerID),
      });
    },
  });
}
